import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, MenuItem, Box, Typography, Alert
} from '@mui/material';
import api from '../../api/api';

const ESTADOS = [
  { value: 'activo', label: 'Activo' },
  { value: 'alta', label: 'Alta Clínica' },
  { value: 'fallecido', label: 'Fallecido' },
  { value: 'transferido', label: 'Transferido' },
  { value: 'cancelado', label: 'Cancelado' }
];

const EstadoAltaModal = ({ open, onClose, hospitalizacion, onSuccess }) => {
  const [formData, setFormData] = useState({
    estado: hospitalizacion?.estado || 'activo',
    diagnostico_definitivo: hospitalizacion?.diagnostico_definitivo || ''
  });
  const [loading, setLoading] = useState(false);
  const [confirmar, setConfirmar] = useState(false); // ← NUEVO ESTADO

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Si cambia el estado de nuevo, reseteamos la confirmación
    if (e.target.name === 'estado') setConfirmar(false);
  };

  const handleSave = async () => {
    // Si el estado original era 'activo' y se cambió a otro, pedimos confirmación
    if (hospitalizacion?.estado === 'activo' && formData.estado !== 'activo' && !confirmar) {
      setConfirmar(true);
      return;
    }

    try {
      setLoading(true);
      const payload = { ...formData };
      if (formData.estado === 'alta') {
        payload.fecha_alta = new Date().toISOString();
      }

      await api.patch(`/hospitalizaciones/${hospitalizacion.id_hospitalizacion}`, payload);
      onSuccess();
      onClose();
    } catch (err) {
      console.error("Error al actualizar estado:", err);
      alert("Error al actualizar la hospitalización");
    } finally {
      setLoading(false);
      setConfirmar(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Actualizar Estado y Diagnóstico</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 1 }}>
          
          {/* Alerta de Confirmación Crítica */}
          {confirmar && (
            <Alert severity="warning" variant="filled" sx={{ fontWeight: 'bold' }}>
              ¿Está seguro de cambiar el estado a "{ESTADOS.find(e => e.value === formData.estado)?.label}"? 
              Esta acción cerrará el caso hospitalario.
            </Alert>
          )}

          <TextField
            select
            label="Estado del Paciente"
            name="estado"
            value={formData.estado}
            onChange={handleChange}
            fullWidth
            disabled={confirmar} // Bloqueamos para que confirme el que eligió
          >
            {ESTADOS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Diagnóstico Definitivo"
            name="diagnostico_definitivo"
            value={formData.diagnostico_definitivo}
            onChange={handleChange}
            multiline
            rows={4}
            fullWidth
            disabled={confirmar}
            placeholder="Describa el diagnóstico final tras los estudios..."
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        {confirmar ? (
          <>
            <Button onClick={() => setConfirmar(false)} color="inherit">
              No, Corregir
            </Button>
            <Button 
              onClick={handleSave} 
              variant="contained" 
              color="warning" 
              disabled={loading}
            >
              Sí, Confirmar Cambio
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onClose} disabled={loading}>Cancelar</Button>
            <Button 
              onClick={handleSave} 
              variant="contained" 
              disabled={loading || !formData.diagnostico_definitivo}
            >
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default EstadoAltaModal;